import { makeStyles } from "@mui/styles";
import Theme from "../../themes/theme";

export default makeStyles((theme: Theme) => ({
  widgetWrapper: {
    display: "flex",
    minHeight: "100%",
  },
  widgetHeader: {
    minHeight: "62px",
    paddingTop: "8px",
    // paddingBottom: "8px",
    paddingLeft: "16px",
    paddingRight: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #EBEBEB",
    marginBottom: theme.spacing(1),
  },
  widgetHeaderTitle: {
    width: "100%",
    color: theme.palette.UI.grey_900,
  },
  widgetsubheading: { width: "100%", color: "#333333" },
  widgetheadingcontainer: {
    display: "flex",
    flexDirection: "column",
  },
  mainChartLabels: {
    textAlign: "center",
  },
  widgetRoot: {
    // boxShadow: theme.customShadows.widgetDark,
  },
  widgetBody: {
    paddingBottom: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
    height: "100%",
  },
  noPadding: {
    padding: 0,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",
  },
  moreButton: {
    margin: -theme.spacing(1),
    padding: 0,
    width: 40,
    height: 40,
    color: theme.palette.text.hint,
    "&:hover": {
      backgroundColor: theme.palette.info.light,
      color: "rgba(255, 255, 255, 0.35)",
    },
  },
  widgetBorder: {
    border: `1px solid ${theme.palette.UI.grey}`,
    borderRadius: 4,
  },
  widgetHeaderWithoutPadding: {
    minHeight: "62px",
    paddingLeft: "16px",
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingRight: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #EBEBEB",
  },
  widgetBodyWithoutPadding: {
    // paddingBottom: theme.spacing(1.5),
    // paddingRight: theme.spacing(1.5),
    // paddingLeft: theme.spacing(1.5),
    height: "100%",
  }
}));
